import React, {useCallback, useEffect, useMemo, useState} from "react";
import {EditLocalStoragePagesData} from "../../../../../../utils/EditLocalStoragePagesData";
import OrderService from "../../../../../../API/orders/orders/organization/OrderService";
import OrderUtil from "../../../../../../utils/orders/OrderUtil";
import Box from "@mui/material/Box";
import {BreadcrumbsComponent} from "../../../../breadcrumb/BreadcrumbComponent";
import Typography from "@mui/material/Typography";
import {Paper, Tooltip} from "@mui/material";
import DataUtil from "../../../../../../utils/common/DataUtil";
import {constantsErrorMessages} from "../../../../../../Constants";
import ModalAlert from "../../../customer-detales/ModalAlert";
import ButtonSelectAction from "../../../../button/ButtonSelectAction";
import {ModalSelectAction} from "../../../../modal/ModalSelectAction";
import ModalSetPlan from "../order/ModalSetPlan";
import OrderTable from "../order/OrderTable";
import {calcFilterData} from "../../../../../../utils/common/calcFilterData";
import {OrderTableFilterData} from "../../../../../../data/FilterTables/OrderTableFilterData";
import {orderStatus, EMPTY_STATUS_FILTER, EMPTY_PLAN_FILTER, EMPTY_ORDER_NUMBER_FILTER, EMPTY_CUSTOMER_NUMBER_FILTER, EMPTY_CUSTOMER_FILTER, EMPTY_HEADER_FILTER, EMPTY_ATTRIBUTES_FILTER, EMPTY_MODEL_FILTER} from "../../../../../../data/OrderStatus";

const Planning = () => {
    const [rowSelection, setRowSelection] = useState([]);
    const [data, setData] = useState([]);
    const [customerList, setCustomerList] = useState([]);
    const [nameList, setNameList] = useState([]);
    const [modelList, setModelList] = useState([]);
    const [attributeList, setAttributeList] = useState([]);
    const [planningList, setPlanningList] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [numberList, setNumberList] = useState([]);
    const [numberCustomerList, setNumberCustomerList] = useState([]);
    const [open, setOpen] = useState(false)
    const [alertData, setAlertData] = useState({});
    const [setPlanModalOpen, setSetPlanModalOpen] = useState(false);
    const [filteredData, setFilteredData] = useState(data)
    const [globalFilter, setGlobalFilter] = useState('');
    const [columnsFilter, setColumnsFilter] = useState([]);
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState?.pageSize !== tableOptions?.pageSize) {
            EditLocalStoragePagesData(`organization/for-write-off`, "pageSize", nextState?.pageSize)
        }
    }
    const handleSearchQuery = (searchQuery, prevData, pageSize, isColumnFilters) => {
        const newColumnsFilter = isColumnFilters ? searchQuery : columnsFilter
        const newGlobalFilter = isColumnFilters ? globalFilter : searchQuery || ""

        const data = [...prevData]
        const globalFilterData = newGlobalFilter ? calcFilterData(data, newGlobalFilter, OrderTableFilterData) : data
        const newData = newColumnsFilter.reduce((accumulator, currentValue) => {
            return calcFilterData(accumulator, currentValue?.value, [OrderTableFilterData.find(el => el.idFromColumnFilter === currentValue.id)])
        }, globalFilterData);

        setFilteredData(newData)

        tableOptionsHandle({
            ...tableOptions,
            totalElements: newData.length,
            pageSize: pageSize ? pageSize : tableOptions?.pageSize
        })

        if (isColumnFilters) {
            setColumnsFilter(searchQuery)
        } else {
            setGlobalFilter(searchQuery || "")
            if (searchQuery !== globalFilter) {
                EditLocalStoragePagesData(`organization/planning`, "searchQuery", searchQuery)
            }
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[`organization/planning`]?.pageSize
        const searchQuery = pagesData[`organization/planning`]?.searchQuery

        return {searchQuery, pageSize}
    }

    const modalActions = [
        {name: "Установить план", type: "plan"},
    ]
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }

    const handleSelectAction = () => {
        setOpen(false)
        setSetPlanModalOpen(true)
    }
    const setLists = (data) => {
        setCustomerList(DataUtil.getListField(data, 'customerName', EMPTY_CUSTOMER_FILTER));
        setNameList(DataUtil.getListChildField(data, 'header', 'name', EMPTY_HEADER_FILTER));
        setModelList(OrderUtil.getEstimateModuleNamesList(data, EMPTY_MODEL_FILTER));
        setAttributeList(OrderUtil.getStatuses(data, 'attributes', EMPTY_ATTRIBUTES_FILTER));
        setPlanningList(DataUtil.getListChildField(data, 'plan', 'name', EMPTY_PLAN_FILTER));
        setStatusList(OrderUtil.getListFieldByEnum(data, 'status', orderStatus, EMPTY_STATUS_FILTER));
        setNumberList(DataUtil.getListField(data, 'number', EMPTY_ORDER_NUMBER_FILTER));
        setNumberCustomerList(DataUtil.getListField(data, 'numberCustomer', EMPTY_CUSTOMER_NUMBER_FILTER));
    }
    useEffect(() => {
        const {searchQuery, pageSize} = getStartPageSize()
        getStartPageSize()
        OrderService.getOrdersPlanning().then(function (response) {
            const data = response.data?.sort((a, b) => b.id - a.id)
            setData(data);
            handleSearchQuery(searchQuery, data, pageSize)
            setLists(data)
        })
            .catch(function (error) {
                handleModalAlert(error, 'error');
            });
    }, []);

    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={"Планирование"}
                path={[
                    {name: "Главная", href: "/"},
                ]}/>
            <Box sx={{display: "flex", flexDirection: "column"}}>
                <Box sx={{display: "flex", flexDirection: "column"}}>
                    <Typography component="p" sx={{fontSize: "24px", fontWeight: 700}}>
                        Планирование
                    </Typography>
                </Box>
                <OrderTable
                    data={data}
                    setData={setData}
                    customerList={customerList}
                    nameList={nameList}
                    modelList={modelList}
                    attributeList={attributeList}
                    planningList={planningList}
                    numberList={numberList}
                    numberCustomerList={numberCustomerList}
                    enableEditing={true}
                    rowSelection={rowSelection}
                    setRowSelection={setRowSelection}
                    tableOptions={tableOptions}
                    tableOptionsHandle={tableOptionsHandle}
                    handleModalAlert={handleModalAlert}
                    planning={true}
                    globalFilter={globalFilter}
                    filteredData={filteredData}
                    handleSearchQuery={handleSearchQuery}
                    columnsFilter={columnsFilter}
                    setLists={setLists}
                    statusList={statusList}
                />
                {Object.keys(rowSelection).length !== 0 && <Paper sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    height: "88px",
                    display: 'flex',
                    justifyContent: "center",
                    alignItems: 'center',
                    backgroundColor: (theme) => theme.palette.primary.lightGrey,
                }} component="footer">
                    <ButtonSelectAction text={"Выбрать действие"} onClick={() => setOpen(true)}/>
                </Paper>}
                <ModalSelectAction
                    open={open}
                    reset={() => setOpen(false)}
                    submit={handleSelectAction}
                    modalActions={modalActions}
                />
                {setPlanModalOpen && <ModalSetPlan
                    open={setPlanModalOpen}
                    handleClose={() => setSetPlanModalOpen(false)}
                    selectedIds={rowSelection}
                    data={data}
                    setData={setData}
                    handleModalAlert={handleModalAlert}
                    setRowSelection={setRowSelection}
                    setLists={setLists}
                />}
                <ModalAlert
                    data={alertData}
                    onClose={() => setAlertData((alert) => ({...alert, open: false}))}
                />
            </Box>
        </Box>
    );
};
export default Planning